export default function (acp, $state) {
    return acp.menu()
        .addChild(acp.menu()
            .title('Početna')
            .icon('<i class="fa fa-home"></i>')
            .link($state.href('dashboard')))

        .addChild(acp.menu()
            .title('Šifranti')

            .addChild(acp.menu()
                .title('Materijali')
                .link($state.href('crud.list', {entity: 'Materijal'})))

            .addChild(acp.menu()
                .title('Grupe radova')
                .link($state.href('crud.list', {entity: 'GrupaRada'})))

            .addChild(acp.menu()
                .title('Vrste radova')
                .link($state.href('crud.list', {entity: 'VrstaRada'})))

            .addChild(acp.menu()
                .title('Protetski radovi')
                .link($state.href('crud.list', {entity: 'ProtetskiRad'})))

            .addChild(acp.menu()
                .title('Cjenici')
                .link($state.href('cjenik')))

            .addChild(acp.menu()
                .title('Firma')
                .link($state.href('crud.list', {entity: 'Firma'})))

            .addChild(acp.menu()
                .title('Ordinacije')
                .link($state.href('ordinacija')))

            .addChild(acp.menu()
                .title('Porezne stope')
                .link($state.href('crud.list', {entity: 'PoreznaStopa'})))

            .addChild(acp.menu()
                .title('Tehničari')
                .link($state.href('crud.list', {entity: 'Tehnicar'})))

            .addChild(acp.menu()
                .title('Valute')
                .link($state.href('crud.list', {entity: 'Valuta'})))

            .addChild(acp.menu()
                .title('Boje')
                .link($state.href('crud.list', {entity: 'Boja'})))

            .addChild(acp.menu()
                .title('Oznake boja')
                .link($state.href('crud.list', {entity: 'OznakaBoje'})))
        )
        .addChild(acp.menu()
            .title('Radni nalozi')
            .link($state.href('radniNalog')))

        .addChild(acp.menu()
            .title('Upute za rad')
            .link($state.href('upute')));
}



// WEBPACK FOOTER //
// ./app/menu.js